import React from 'react';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Compliance = () => {
  return (
    <div className="w-full bg-white">
      <PageHeader 
        title="Compliance & Safety Consulting" 
        description="Navigate overlapping regulatory requirements with practical compliance support." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg max-w-3xl">
          <p className="text-sm text-amber-800 font-medium">
            <strong>Note:</strong> Boes & Boes provides practical compliance consulting based on industry standards and best practices. Our services do not constitute legal advice.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7 prose prose-slate prose-lg">
            <p>
              Modern organizations face a maze of overlapping requirements from OSHA, EPA, PHMSA, CMS, FFIEC, NERC-CIP, NFPA, and internal corporate standards. We help you cut through the confusion to identify vulnerabilities before an incident or an audit occurs.
            </p>

            <h3 className="text-brand-navy font-bold">Consulting Services</h3>
            <div className="grid sm:grid-cols-2 gap-4 not-prose">
              {[
                'Compliance gap assessments',
                'Plan and procedure reviews',
                'HAZWOPER compliance support',
                'EPA Tier II and EPCRA support',
                'NFPA 70E and 70B safety support',
                'Audit preparation',
                'Accident investigation systems',
                'Corrective-action tracking',
                'Training-record reviews',
                'Multi-site consistency reviews',
                'High-voltage safety-plan development',
                'Leadership safety briefings'
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-3 bg-brand-light rounded-lg border border-slate-200">
                  <SafeIcon icon={FiIcons.FiShield} className="text-brand-navy shrink-0" />
                  <span className="text-sm font-semibold text-slate-800">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-square">
              <img 
                src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=800&auto=format&fit=crop" 
                alt="Industrial Inspection" 
                className="w-full h-full object-cover" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/90 to-transparent flex items-end p-8">
                <div>
                  <h4 className="text-white font-bold text-xl mb-2">Building the Business Case</h4>
                  <p className="text-slate-200 text-sm font-medium">
                    We help EHS managers build clear leadership briefings and business cases to secure necessary safety investments.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Compliance;